export const SHOW_COMMON_MODAL = 'SHOW_COMMON_MODAL';
export const HIDE_COMMON_MODAL = 'HIDE_COMMON_MODAL';
